import { useEffect, useState } from "react";

// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// RasPm Dashboard examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// EditCategory page components
import EditForm from "../components/EditForm";

// EditCategory layout schemas for form and form fields
import validations from "../schemas/validations";
import form from "../schemas/form";
import initialValues from "../schemas/initialValues";

import { RequestService } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import { useLocation, useNavigate } from "react-router-dom";

function getSteps() {
  return ["معلومات الفئة"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <EditForm formData={formData} />;

    default:
      return null;
  }
}

function EditCategory() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [initialValuesState, setInitialValues] = useState({ ...initialValues });

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleBack = () => setActiveStep(activeStep - 1);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const submitForm = async (values, actions) => {
    await sleep(1000);

    await RequestService.put("category", values)
      .then(async (result) => {
        if (result.status === 200) {
          setShow(!show);
          await sleep(1000);
          navigate("/pages/projects/viewcategroies");
        } else {
          setError(!error);
        }
      })
      .catch((errorres) => {
        setMessage(errorres.response.data.message);
        setError((prevError) => !prevError);
      });

    actions.setSubmitting(false);
    actions.resetForm();

    setActiveStep(0);
  };

  const handleSubmit = (values, actions) => {
    if (isLastStep) {
      submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await RequestService.get("category/" + id)
        .then(async (result) => {
          if (result.status === 200 && result.data.data !== null) {
            setInitialValues(result.data.data);
            setMessage(result.data.message);
          } else {
            setError((prevError) => !prevError);
          }
        })
        .catch((errorres) => {
          setMessage(errorres.response.data.message);
          setError((prevError) => !prevError);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content={message}
        dateTime="0 seconds ago"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="حدث خطأ ما"
        content={message}
        dateTime="0 seconds ago"
        open={error}
        close={toggleSnackbar2}
      />
      <DashboardNavbar />
      <MDBox py={3} mb={20} height="65vh">
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={8}>
            <Formik
              initialValues={initialValuesState}
              enableReinitialize
              validationSchema={currentValidation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setValues }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={2} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox p={3}>
                      <MDBox>
                        {getStepContent(activeStep, {
                          values,
                          touched,
                          formField,
                          errors,
                          setValues,
                        })}
                        <MDBox mt={2} width="100%" display="flex" justifyContent="space-between">
                          {activeStep === 0 ? (
                            <MDBox />
                          ) : (
                            <MDButton variant="gradient" color="light" onClick={handleBack}>
                              السابق
                            </MDButton>
                          )}
                          <MDButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isLastStep ? "تحديث" : "التالي"}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditCategory;
